import React, { useState } from 'react';
import { FaWhatsapp } from 'react-icons/fa';

const WhatsappButton = () => {
    const [showChatWidget, setShowChatWidget] = useState(false);

    const handleWhatsappIconClick = () => {
        setShowChatWidget(!showChatWidget);
    };

    const widgetStyles = {
        container: {
            position: 'fixed',
            bottom: '40px',
            right: '80px',
            zIndex: '999',
        },
        icon: {
            cursor: 'pointer',
            backgroundColor: '#26d48c ',
            padding: '10px',
            borderRadius: '50%',
        },
        widget: {
            position: 'fixed',
            bottom: '97px',
            right: '95px',
            zIndex: '999',
            width: '389px',
            fontFamily: 'Arial, sans-serif',
            boxShadow: '0 4px 8px rgba(0,0,0,0.1)',
            borderRadius: '8px',
            backgroundColor: '#fff',
            border: '1px solid #ddd',
        },
        header: {
            backgroundColor: '#26d48c ',
            color: '#fff',
            padding: '12px 16px',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'space-between',
            borderRadius: '8px 8px 0 0',
        },
        chatBox: {
            padding: '16px',
            borderBottom: '1px solid #e0e0e0',
            backgroundColor: '#fff',
            borderRadius: '10px',
            margin: '15px',
        },
        footer: {
            backgroundColor: '#f7f7f7',
            borderRadius: '0 0 8px 8px',
            padding: '10px',
            textAlign: 'center',
        },
        sendButton: {
            backgroundColor: '#17A2B8',
            color: '#fff',
            textDecoration: 'none',
            padding: '8px 16px',
            borderRadius: '4px',
            fontWeight: 'bold',
            display: 'inline-block',
        },
        poweredBy: {
            marginTop: '10px',
            fontSize: '12px',
            color: '#006eff6e',
        },
    };

    return (
        <div id="whatsapp-button-container" style={widgetStyles.container}>
            <div id="whatsapp-icon" onClick={handleWhatsappIconClick} style={widgetStyles.icon}>
                <FaWhatsapp style={{ fontSize: '30px', color: 'white' }} />
            </div>
            {showChatWidget && (
                <div id="whatsapp-chat-widget" style={widgetStyles.widget} onClick={(e) => e.stopPropagation()}>
                    <div className="wa-chat-box" style={{ display: 'block', borderRadius: '8px 8px 0 0', backgroundImage: `url('https://user-images.githubusercontent.com/99333830/277576700-059390fb-4890-40dc-8a77-34942ff2e9db.png')` }}>
                    <div className="wa-chat-box-header" style={{ backgroundColor: '#26d48c ', color: '#fff', padding: '12px 16px', display: 'flex', alignItems: 'center', justifyContent: 'space-between', borderRadius: '8px 8px 0 0', height:'87px'}}>
                            <img className="wa-chat-box-brand" onError={(e) => e.target.src = 'favicon.ico'} src="https://smartsikshana.com/img/favicon.ico" alt="Logo" style={{ width: '35px', height: '35px', marginRight: '8px', borderRadius: '25px' }} />
                            <div className="wa-chat-box-brand-text" style={{ marginLeft: '-60px' }}>
                                <div className="wa-chat-box-brand-name">INFLU-ENCER</div>
                                <div className="wa-chat-box-brand-subtitle">Typically replies within an hour</div>
                            </div>
                            <div className="wa-chat-bubble-close-btn" onClick={handleWhatsappIconClick} style={{ cursor: 'pointer' }}>
                                <img src="https://cdn.shopify.com/s/files/1/0070/3666/5911/files/Vector.png?574" style={{ width: '20px', height: '20px' }} alt="Close" />
                            </div>
                        </div>
                    <div className="wa-chat-box-content" style={{ padding: '16px', borderBottom: '1px solid #e0e0e0', backgroundColor: '#fff', width: '182px', height: '87px', margin: '15px', borderRadius: '10px' }}>
                            <div className="wa-chat-box-content-chat">
                                <div className="wa-chat-box-content-chat-brand" style={{ color: 'rgba(0, 0, 0, 0.4);', fontSize: '13px', fontWeight: '700;', lineHeight: '18px;' }}>INFLU-ENCER</div>
                                <div className="wa-chat-box-content-chat-welcome" style={{ color: '#000', fontSize: '14px' }}>Hi there!<br />How can we help you?</div>
                            </div>
                        </div>
                        <div className="wa-chat-box-send" style={{ backgroundColor: '#f7f7f7', borderRadius: '0 0 8px 8px', height: '100px' }}>
                            <a role="button" rel='noreferrer' target="_blank" href="https://api.whatsapp.com/send?phone=918977917579&amp;text=Hello, I have a question about https%3A%2F%2Fwww.INFLU-ENCER.com%2F" title="WhatsApp" className="wa-chat-box-content-send-btn" style={{ backgroundColor: '#26d48c ', color: '#fff', textDecoration: 'none', display: 'inline-block', padding: '8px 16px', borderRadius: '26px', fontWeight: 'bold', fill: '#fff' ,marginLeft: '33px' , marginTop: '18px',}}>
                                <svg width="20" height="20" viewBox="0 0 90 90" xmlns="http://www.w3.org/2000/svg" fillRule="evenodd" clipRule="evenodd" className="wa-chat-box-content-send-btn-icon" style={{ verticalAlign: 'middle', marginRight: '0px', width: '230px', alignItems: 'center', fill: 'rgb(255, 255, 255);', color: 'rgb(255, 255, 255) !important;' }}>
                                    <path d="M90,43.841c0,24.213-19.779,43.841-44.182,43.841c-7.747,0-15.025-1.98-21.357-5.455L0,90l7.975-23.522   c-4.023-6.606-6.34-14.354-6.34-22.637C1.635,19.628,21.416,0,45.818,0C70.223,0,90,19.628,90,43.841z M45.818,6.982   c-20.484,0-37.146,16.535-37.146,36.859c0,8.065,2.629,15.534,7.076,21.61L11.107,79.14l14.275-4.537   c5.865,3.851,12.891,6.097,20.437,6.097c20.481,0,37.146-16.533,37.146-36.857S66.301,6.982,45.818,6.982z M68.129,53.938   c-0.273-0.447-0.994-0.717-2.076-1.254c-1.084-0.537-6.41-3.138-7.4-3.495c-0.993-0.358-1.717-0.538-2.438,0.537   c-0.721,1.076-2.797,3.495-3.43,4.212c-0.632,0.719-1.263,0.809-2.347,0.271c-1.082-0.537-4.571-1.673-8.708-5.333   c-3.219-2.848-5.393-6.364-6.025-7.441c-0.631-1.075-0.066-1.656,0.475-2.191c0.488-0.482,1.084-1.255,1.625-1.882   c0.543-0.628,0.723-1.075,1.082-1.793c0.363-0.717,0.182-1.344-0.09-1.883c-0.27-0.537-2.438-5.825-3.34-7.977   c-0.902-2.15-1.803-1.792-2.436-1.792c-0.631,0-1.354-0.09-2.076-0.09c-0.722,0-1.896,0.269-2.889,1.344" />
                                </svg>
                                <span className="wa-chat-box-content-send-btn-text" style={{ marginLeft: '-100px', marginRight: '120px' }}>Ask</span>
                            </a>
                            <div className="wa-chat-box-poweredby" style={{ marginLeft: '137px', marginTop: '13px' }}>⚡ by <a href="https://wati.io/?utm_source=shopify&amp;utm_medium=chat_widget&amp;utm_campaign=shopify_widget" target="_blank" rel="noreferrer" style={{ color: "#006eff6e;" }}>wati.io</a></div>
                        </div>
                    </div>
                </div>
            )}
        </div>
    );
};

export default WhatsappButton;
